"use client";

import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const differentiators = [{
  title: "Diagnose first",
  description: "We use the Wellbeing Risk Radar to identify exactly where stress is building before recommending any intervention.",
  delay: "delay-100"
}, {
  title: "Strategy, not activity",
  description: "We help organisations build a practical plan, not a programme of wellbeing events that doesn't address the underlying causes.",
  delay: "delay-200"
}, {
  title: "Measure what changes",
  description: "Every engagement includes a way to track progress, so you can demonstrate impact to your board and your team.",
  delay: "delay-300"
}];
export default function WhatMakesUsDifferent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="what-makes-us-different" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6" ref={ref}>
        <div className={`flex flex-col items-center text-center space-y-4 mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight">
            How we work
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-sans">Our approach ensures we deliver practical, lasting results for your business by focusing on what truly matters.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {differentiators.map((item, i) => {
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${item.delay} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="bg-white border-none shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300 h-full rounded-2xl">
                  <CardHeader className="pb-4">
                    <div className="size-4 rounded-lg bg-[#efc318] mb-6 shadow-sm" />
                    <CardTitle className="text-xl font-default font-bold text-[#38457C] leading-tight">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground font-sans text-base leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}